import { render } from "./SelectorDestino.vue?vue&type=template&id=2bcd0cc0&scoped=true"
import script from "./SelectorDestino.vue?vue&type=script&lang=js"
export * from "./SelectorDestino.vue?vue&type=script&lang=js"

import "./SelectorDestino.vue?vue&type=style&index=0&id=2bcd0cc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcd0cc0"]])

export default __exports__